import { Component } from '@theme/component';

/** R21 header motion; menu, search, localization and cart keep their own controllers. */
class AtelierHeader extends Component {
  #listeners; #observer; #frame; #group; #scroller;

  connectedCallback() {
    super.connectedCallback();
    this.#release();
    this.#group = this.closest('#header-group');
    if (!this.#group) return;
    this.#scroller = this.closest('.page-wrapper');
    this.#listeners = new AbortController();
    const options = { signal: this.#listeners.signal, passive: true };
    document.addEventListener('scroll', this.#onScroll, { ...options, capture: true });
    window.addEventListener('resize', this.#measure, options);
    this.#observer = new ResizeObserver(this.#measure);
    this.#observer.observe(this.#group);
    this.#measure();
  }

  #measure = () => {
    // Measure merchant announcements, including wrapping after opening the advisor.
    const offset = Math.max(0, this.getBoundingClientRect().top - this.#group.getBoundingClientRect().top);
    this.#group.style.setProperty('--atelier-announcement-height', `${offset}px`);
    this.#sync();
  };

  #onScroll = event => {
    // Thumbnail rails, menus and dialogs must not change the page's header state.
    if (event.target !== document && event.target !== this.#scroller) return;
    if (this.#frame != null) return;
    this.#frame = requestAnimationFrame(() => { this.#frame = null; this.#sync(); });
  };

  #sync = () => {
    const y = window.scrollY + (this.#scroller?.scrollTop || 0);
    this.classList.toggle('is-compact', y > 120);
  };

  #release() {
    this.#listeners?.abort();
    this.#observer?.disconnect();
    if (this.#frame != null) cancelAnimationFrame(this.#frame);
    this.#frame = null;
    this.#group?.style.removeProperty('--atelier-announcement-height');
    this.classList.remove('is-compact');
  }

  disconnectedCallback() { this.#release(); super.disconnectedCallback(); }
}

if (!customElements.get('fivepoint-atelier-header')) customElements.define('fivepoint-atelier-header', AtelierHeader);
